import { clientApi } from 'api';
import { AxiosRequestConfig } from 'axios';
import { getFromData } from 'client/helpers/getFromData';
import { splitTagsString } from 'client/helpers/splitTagsString';
import { ICategoryTour } from 'client/models/ICategoryTour';
import IPostForm from 'client/models/IPostForm';
import ICategoryTourForm from '../../../models/ICategoryTourForm';

const baseUrl = '/category-tours';

// Créer une nouvelle catégorie de tour
export const addCategoryTour = () => async (values: ICategoryTourForm, config?: AxiosRequestConfig) => {
  const categoryTourData = {
    name: values.name,
    description: values.description,
  };

  const response = await clientApi.post(baseUrl, categoryTourData, config);

  return response;
};

// Récupérer une catégorie par ID
export const getCategoryTourById = () => async (categoryTourId: string) => {
  const response = await clientApi.get(`${baseUrl}/${categoryTourId}`);

  return response;
};

// Récupérer une catégorie par slug
export const getCategoryTourBySlug = () => async (slug: string) => {
  const response = await clientApi.get(`${baseUrl}/slug/${slug}`);

  return response;
};

// Supprimer une catégorie
export const deleteCategoryTourById = () => async (categoryTourId: string) => {
  const response = await clientApi.delete(`${baseUrl}/${categoryTourId}`);

  return response;
};

// Mettre à jour une catégorie
export const updateCategoryTour = () => async (
  categoryTourId: string,
  values: Partial<ICategoryTourForm>,
  config?: AxiosRequestConfig,
) => {
  const updateData: { name?: string; description?: string } = {};

  if (values.name) {
    updateData.name = values.name;
  }
  if (values.description) {
    updateData.description = values.description;
  }

  const response = await clientApi.put(`${baseUrl}/${categoryTourId}`, updateData, config);

  return response;
};

// Récupérer toutes les catégories
export const getAllCategoryTours = (filter?: {
  countryLetter?: string;
  category?: string;
}) => async () => {
  return await clientApi.get(baseUrl);
};

// Ajouter/Retirer une catégorie des favoris
export const toggleFavorCategoryTour = () => async (categoryTourId: string) => {
  const response = await clientApi.post(`${baseUrl}/${categoryTourId}/favor`);

  return response;
};
